//  一些数据处理工具
import _ from 'lodash'
import OSSClient from '../components/Uploads/OSS-client'

/**
 * 过滤对象键值为空的键
 * @param {*} obj 
 * @returns 
 */
const filterEmptyKey = function (obj = {}) {
    let newObj = {}
    for (const key in obj) {
        const v = obj[key]
        if (_.isNull(v) || _.isUndefined(v) || (_.isObjectLike(v) && _.isEmpty(v))) {
            continue;
        }
        newObj[key] = obj[key]
    }
    return newObj
}

/**
 * 返回keys中的下标(满足obj[key]不为空)
 * @param {Array} keys 将要查询obj的键名数组
 * @param {Object} obj 将要查询的对象
 * @returns {Array} NotEmptyIndexs
 */
const getNotEmptyIndexs = function (keys = [], obj = {}) {
    const NotEmptyIndexs = [];
    keys.forEach((key, index) => {
        if (!_.isEmpty(obj[key])) {
            NotEmptyIndexs.push(index)
        }
    })
    return NotEmptyIndexs;
}
export const base64toFile = (base, filename) => {
    var arr = base.split(',');
    var mime = arr[0].match(/:(.*?);/)[1];
    var suffix = mime.split("/")[1];
    var bstr = window.atob(arr[1]);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    //转换成file对象
    return new File([u8arr], `${filename}.${suffix}`, { type: mime });
}
// 图片剪裁
const cropImg = (url, config) => {
    return new Promise((resolve, reject) => {
        const { type, max } = config
        // 获取图片宽度和高度
        const image = new Image();
        image.src = url;
        image.crossOrigin = 'Anonymous';
        image.onload = () => {
            const width = image.width
            const height = image.height
            // 图片宽度大于要求，等比例缩小
            let aspectRatio = 0,
                newWidth = 0,
                newHeight = 0;
            if ((type === 'width')) {
                if (max >= width) {
                    resolve(url);
                    return
                }

                aspectRatio = width / height;
                newWidth = max - 1;
                newHeight = Math.floor(newWidth / aspectRatio);
            } else {
                if (max >= height) {
                    resolve(url);
                    return
                }
                aspectRatio = height / width;
                newHeight = max;
                newWidth = Math.floor(newHeight / aspectRatio);
            }
            // 创建一个 canvas 来压缩图片
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = newWidth;
            canvas.height = newHeight;

            ctx.drawImage(image, 0, 0, newWidth, newHeight);
            const match = url.match(/.*\.([^?]*)/)
            const fileType = match[1];
            const dataUrl = canvas.toDataURL(`image/${fileType === 'jpg' ? 'jpeg' : fileType}`, 1);
            const file = base64toFile(dataUrl, `clip_${new Date().getTime()}_${_.random(99999)}`)
            OSSClient.getInstance().singleUpload(file.name, file, {
                success(res) {
                    resolve(res.url);
                },
                fail() {
                    resolve(url);
                }
            })
        }

    });
}

export const getBytesCount = (text = '') => {
    let bytesCount = 0;
    for (let i = 0; i < text.length; i++) {
        const code = text.charCodeAt(i);
        // 判断是否为中文、中文符号或中文标点
        if ((code >= 0x4e00 && code <= 0x9fff) || // 中文字符
            (code >= 0x3000 && code <= 0x303F) || // 中文标点符号
            (code >= 0xff00 && code <= 0xffef)) { // 全角符号
            bytesCount += 2;
        } else {
            bytesCount += 1; // 英文字符和半角符号
        }
    }
    return bytesCount;
}
// 仅汉字为2个字符，其余字符为1个字符
export const getBytesCount_v2 = (text = '') => {
    let bytesCount = 0;
    for (let i = 0; i < text.length; i++) {
        const code = text.charCodeAt(i);
        // 判断是否为中文
        if ((code >= 0x4e00 && code <= 0x9fff)) { 
            bytesCount += 2;
        } else {
            bytesCount += 1; // 英文字符和半角符号
        }
    }
    return bytesCount;
}
// 是否存在中文字符
export const checkEnglishText = (str='') => {
    if(/[一-龥　-〿＀-￯]/.test(str)){
        return true
    }
    return false
}

export default {
    filterEmptyKey,
    getNotEmptyIndexs,
    base64toFile,
    cropImg
}
